import api, { URLS } from "@/services/api.js";

const BASE_URL = `${URLS.API_FGTAS}/usuario`;

export const buscarDadosUsuarioLogado = () => {
	const url = `${BASE_URL}/dados`;
	return api.get(url);
};

export const salvarPerfilUsuarioService = (data) => {
	const url = `${BASE_URL}/salvar-perfil`;
	return api.put(url, data);
};

export const cadastrarUsuario = (data) => {
	const url = `${BASE_URL}/cadastrar`;
	return api.post(url, data);
};

export const editarAcessoAdmin = (data) => {
	const url = `${BASE_URL}/admin/editar-acesso`;
	return api.put(url, data);
};

export const editarUsuario = (id, data) => {
	const url = `${BASE_URL}/${id}`;
	return api.put(url, data);
};

export const listarAdmin = (params, filtros) => {
	const url = `${BASE_URL}`;
	return api.get(url, { params: { ...params, ...filtros } });
};

export const buscarDadosUsuarioAdmin = (cpf) => {
	const url = `${BASE_URL}/admin/dados/${cpf}`;
	return api.get(url);
};

export const buscarDadosUsuarioPorId = (id) => {
	const url = `${BASE_URL}/${id}`;
	return api.get(url);
};

export const buscarUsuariosAtendimento = () => {
	const url = `${BASE_URL}/usuarios-atendimento`;
	return api.get(url);
};

export const atualizarPerfilUsuario = (id, data) => {
	const url = `${BASE_URL}/${id}/perfil`;
	return api.put(url, data);
};
